const mergeCellsIfEqual = (matrix: any[][]) => {
  if (!matrix) {
    return;
  }
  const mergeCells: any[] = [];
  const rows = matrix.length;
  const cols = matrix[0].length;

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < rows; i++) {
    // eslint-disable-next-line no-plusplus
    for (let j = 0; j < cols; j++) {
      const cellValue = matrix[i][j];

      if (cellValue) {
        // check if the current cell has already been merged
        const merged = mergeCells.some((mergedCell) => {
          return (
            i >= mergedCell.row &&
            i < mergedCell.row + mergedCell.rowspan &&
            j >= mergedCell.col &&
            j < mergedCell.col + mergedCell.colspan
          );
        });

        if (!merged) {
          // find cells to the right with the same value
          let colspan = 1;
          // eslint-disable-next-line no-plusplus
          for (let k = j + 1; k < cols; k++) {
            if (matrix[i][k] === cellValue) {
              // eslint-disable-next-line no-plusplus
              colspan++;
            } else {
              break;
            }
          }

          // find cells below with the same value
          let rowspan = 1;
          // eslint-disable-next-line no-plusplus
          for (let l = i + 1; l < rows; l++) {
            let rowHasSameValue = true;
            // eslint-disable-next-line no-plusplus
            for (let m = j; m < j + colspan; m++) {
              if (matrix[l][m] !== cellValue) {
                rowHasSameValue = false;
                break;
              }
            }
            if (rowHasSameValue) {
              // eslint-disable-next-line no-plusplus
              rowspan++;
            } else {
              break;
            }
          }

          // if we found any cells with the same value, add them to the mergeCells array
          if (colspan > 1 || rowspan > 1) {
            mergeCells.push({ row: i, col: j, rowspan, colspan });
          }
        }
      }
    }
  }

  return mergeCells;
};

export default mergeCellsIfEqual;
